import React, { useState, useEffect } from "react";
import { includes } from "lodash";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, NavItem } from "reactstrap";
import useAxios from 'hooks/useAxios';
import { Alert } from "bootstrap";

const Subheader = (props) => {
  const { modules } = props;

  const { pathname } = useLocation();

  const hasModule = (code) => {
    return modules.length > 0 && modules.filter(m => m.code == code).length > 0;
  }

  const renderClientDashboard = () => {
      return (
        <NavItem>
          <Link
            to="/clinetdashboard"
            className={`nav-link ${includes(pathname, "/clinetdashboard") ? "active" : ""
              }`}
          >
            <span>PBM Dashboard</span>
          </Link>
        </NavItem>
      )
  }
 
  return (
    <Navbar color="dark" dark className="app-subheader">
      <Nav>
        {renderClientDashboard()}
      </Nav>
    </Navbar>
  );
};

export default Subheader;
